import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
	data: [],
	applicationErrors: [],
	applicationInputValues: {},
	filters: {
		applicant: [],
		desired: [],
		statuses: [],
		projects: []
	}
};

export const singleApplicationSlice = createSlice({
	name: 'singleApplication',
	initialState,
	reducers: {
		reducerGetSingleApplication: (state: Draft<any>, action: PayloadAction<any>) => {
			state.data = action.payload
		},
		reducerSingleApplicationIV: (state: Draft<any>, action: PayloadAction<any>) => {
			state.applicationInputValues = action.payload
		},
		reducerSingleApplicationErrors: (state: Draft<any>, action: PayloadAction<any>) => {
			state.applicationErrors = action.payload
		},
		reducerSingleApplicationStatus: (state: Draft<any>, action: PayloadAction<any>) => {
			state.clientsStatus = action.payload;
		},
		reducerSingleApplicationStatusMessage: (state: Draft<any>, action: PayloadAction<any>) => {
			state.clientsStatusMessage = action.payload;
		},

	},
});

export const {
	reducerSingleApplicationStatusMessage,
	reducerSingleApplicationStatus,
	reducerSingleApplicationErrors,
	reducerGetSingleApplication,
	reducerSingleApplicationIV,
} = singleApplicationSlice.actions;

export default singleApplicationSlice.reducer;
